import { render, staticRenderFns } from "./CoursePicker.vue?vue&type=template&id=64531030&scoped=true&"
import script from "./CoursePicker.vue?vue&type=script&lang=js&"
export * from "./CoursePicker.vue?vue&type=script&lang=js&"
import style0 from "./CoursePicker.vue?vue&type=style&index=0&id=64531030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64531030",
  null
  
)

export default component.exports